/* eslint-disable no-empty, no-redeclare, no-unused-vars */

import { $ as jquery } from 'jquery';
import { i18n } from '../core/i18n.js';
import { laydate } from './laydate.js';
import { form } from './form.js';
import { upload } from './upload.js';
import { laypage } from './laypage.js';
import { layer } from './layer.js';
import { createMediaCategoryTree } from './mediaCategoryTree.js';
import { getMediaManageLayerOptions, getMediaDialogFormOptions, createMediaFormFieldHtml, createMediaConfirmHtml, createMediaMobileBar, bindMediaMobilePanels, createMediaSelectionHelper, createMediaDialogFooter, bindMediaDialogFooter } from './mediaManageResponsive.js';

var $ = jquery;
var Fancybox = window.layui && window.layui.fancybox ? window.layui.fancybox : window.Fancybox;
	var trimText = function(value){
		return value == null ? '' : String(value).trim();
	};
	var escapeHtml = function(value){
		return String(value == null ? '' : value)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	};
	i18n.set({
		messages: {
			'zh-CN': {
				musicManage: {
					addGroup: '添加分组',
					allMusic: '所有音乐',
					dateRange: '日期范围',
					fileName: '文件名',
					search: '搜索',
					delete: '删除',
					move: '移动',
					uploadMusic: '上传音乐',
					selectAllPage: '本页全选',
					selectedCount: '已选 {count} 个',
					selectGroup: '选择分组',
					moveMusic: '移动音乐',
					moveSuccess: '移动成功',
					moveFailed: '移动失败',
					selectMusicToMove: '请选择要移动的音乐?',
					deleteMusic: '删除音乐',
					confirmDeleteMusic: '真的要删除选择的音乐吗?',
					deleteSuccess: '删除成功',
					deleteFailed: '删除失败',
					selectMusicToDelete: '请选择要删除的音乐?',
					maxSelect: '最多只能选{max}个',
					renameFile: '修改文件名【{name}】',
					fileNameLabel: '文件名',
					renameSuccess: '修改成功',
					renameFailed: '修改失败',
					fileNameRequired: '文件名不能为空',
					newGroup: '新建分组',
					groupName: '分组名称',
					groupNameRequired: '请填写分组名称',
					groupCancel: '取消',
					edit: '修改',
					deleteGroup: '删除分组',
					confirmDeleteGroup: '真的要删除该分组吗?',
					deleteGroupWithChildren: '请先删除子分组',
					selectMusic: '选择音乐',
					confirm: '确定',
					cancel: '取消'
				}
			},
			'en-US': {
				musicManage: {
					addGroup: 'Add Group',
					allMusic: 'All Music',
					dateRange: 'Date Range',
					fileName: 'File Name',
					search: 'Search',
					delete: 'Delete',
					move: 'Move',
					uploadMusic: 'Upload Music',
					selectAllPage: 'Select all on page',
					selectedCount: 'Selected {count}',
					selectGroup: 'Select Group',
					moveMusic: 'Move Music',
					moveSuccess: 'Moved successfully',
					moveFailed: 'Move failed',
					selectMusicToMove: 'Please select music item(s) to move.',
					deleteMusic: 'Delete Music',
					confirmDeleteMusic: 'Are you sure you want to delete the selected music items?',
					deleteSuccess: 'Deleted successfully',
					deleteFailed: 'Delete failed',
					selectMusicToDelete: 'Please select music item(s) to delete.',
					maxSelect: 'You can select up to {max} items',
					renameFile: 'Rename File [{name}]',
					fileNameLabel: 'File Name',
					renameSuccess: 'Renamed successfully',
					renameFailed: 'Rename failed',
					fileNameRequired: 'File name is required',
					newGroup: 'New Group',
					groupName: 'Group Name',
					groupNameRequired: 'Please enter a group name',
					groupCancel: 'Cancel',
					edit: 'Edit',
					deleteGroup: 'Delete Group',
					confirmDeleteGroup: 'Are you sure you want to delete this group?',
					deleteGroupWithChildren: 'Please delete child groups first',
					selectMusic: 'Select Music',
					confirm: 'Confirm',
					cancel: 'Cancel'
				}
			}
		}
	});
	var t = function(key, fallback, params){
		return i18n.translate('musicManage.' + key, params, { default: fallback });
	};

	var openMusicPreview = function(src){
		if(!src){
			return;
		}
		var safeSrc = escapeHtml(src);
		var viewportWidth = Math.max($(window).width() - 32, 280);
		var width = Math.min(viewportWidth, 560);
		layer.open({
			type: 1,
			title: false,
			closeBtn: 1,
			shadeClose: true,
			resize: false,
			scrollbar: false,
			skin: 'layui-layer-g3ys-form media-preview-layer media-preview-layer-audio',
			area: [width + 'px', 'auto'],
			content: "<div class='media-preview-wrap media-preview-audio-wrap'><audio src='" + safeSrc + "' controls='controls' autoplay preload='metadata' class='media-preview-audio'></audio></div>",
			success: function(layero){
				var audioNode = $(layero).find('.media-preview-audio').get(0);
				if(audioNode && audioNode.play){
					var playResult = audioNode.play();
					if(playResult && playResult.catch){
						playResult.catch(function(){});
					}
				}
			}
		});
	};
	
	function MusicManage(){
		
	}
	var musicManage = MusicManage;
	
	musicManage.prototype.options={};
	musicManage.prototype.init=function(options){
		this.options=options;
		this._state = this._state || {
			data: {},
			dataMultiple: [],
			categoryId: 0,
			initCategories: null,
			categoryTree: null
		};
	}
	musicManage.prototype.render=function(){
		var state = this._state || (this._state = {
			data: {},
			dataMultiple: [],
			categoryId: 0,
			initCategories: null,
			categoryTree: null
		});
		var music_data = state.data || {};
		var music_data_multiple = Array.isArray(state.dataMultiple) ? state.dataMultiple : [];
		var category_id = state.categoryId || 0;
		var init_categorys = state.initCategories;
		var category_tree = state.categoryTree;
		var syncState = function(){
			state.data = music_data;
			state.dataMultiple = music_data_multiple;
			state.categoryId = category_id;
			state.initCategories = init_categorys;
			state.categoryTree = category_tree;
		};
		syncState();
		var load=layer.load();
		var musicUploadUrl=this.options.musicUploadUrl;
		var musicDelUrl=this.options.musicDelUrl;
		var musicMoveUrl=this.options.musicMoveUrl;
		var editMusicNameUrl=this.options.editMusicNameUrl;
		var musicCategory=this.options.musicCategory;
		var musicCategoryUrl=this.options.musicCategoryUrl;
		var musicCategoryUpdateUrl=this.options.musicCategoryUpdateUrl;
		var musicCategoryDelUrl=this.options.musicCategoryDelUrl;

	var multiple=this.options.multiple;
		var that;
		
		var size = this.options.size;
		var acceptMime = this.options.acceptMime;
		var headers = this.options.headers;
		var field = this.options.field;
		var exts = this.options.exts;
		var musicUploadData =this.options.musicUploadData;
		
		var musicUrl=this.options.musicUrl;
		var musicDialogOptions = getMediaDialogFormOptions();
		var music_s_time=0;
		var music_e_time=0;
		var music_total=0;
		var callback=this.options.callback;
		var musicMax=this.options.musicMax||12;
		
		var music_manage_div= this.options.elem+"_music_manage_div";
		var music_manage= this.options.elem+"_music_manage";
		var music_upload= this.options.elem+"_music_upload";
		var music_del= this.options.elem+"_music_del";
		var music_move= this.options.elem+"_music_move";
		var music_category= this.options.elem+"_music_category";
		var music_category_add=this.options.elem+"_music_category_add";
		var music_search_input=this.options.elem+"_music_search_input";
		var music_search_date=this.options.elem+"_music_search_date";
		var music_search_btn=this.options.elem+"_music_search_btn";
		var music_mobile_category_toggle=this.options.elem+"_music_mobile_category_toggle";
		var music_mobile_search_toggle=this.options.elem+"_music_mobile_search_toggle";
		var music_content=this.options.elem+"_music_content";
		var music_page=this.options.elem+"_music_page";
		var music_confirm= this.options.elem+"_music_confirm";
		var music_cancel= this.options.elem+"_music_cancel";
		var music_item=this.options.elem+"_music_item";
		var music_select_all=this.options.elem+"_music_select_all";
		var music_select_all_num=this.options.elem+"_music_select_all_num";
		var getMusicItems = function(){
			return $("#"+music_content+" a");
		};
		var getMusicItemData = function(item){
			item=$(item);
			return {
				id:item.attr('data-id'),
				path:item.attr('data-path'),
				size:item.attr('data-size'),
				title:item.find('span').text()
			};
		};
		var musicSelection = createMediaSelectionHelper({
			multiple: multiple,
			max: musicMax,
			selectClass: 'music-item-select',
			getItems: getMusicItems,
			getSelectedItems: function(){
				return music_data_multiple;
			},
			setSelectedItems: function(items){
				music_data_multiple = items;
				syncState();
			},
			getSingleSelected: function(){
				return music_data;
			},
			setSingleSelected: function(item){
				music_data = item;
				syncState();
			},
			setSelectedCount: function(count){
				$("#"+music_select_all_num).text(count);
			},
			setSelectAllChecked: function(checked){
				$("#"+music_select_all).prop('checked', checked);
			},
			getItemData: getMusicItemData,
			markSelected: function(item){
				$("#"+music_item+"_"+item.id).addClass('music-item-select');
			},
			onLimit: function(){
				layer.msg(t('maxSelect', '最多只能选{max}个', {max: musicMax}));
			}
		});
		var updateMusicSelectedCount = musicSelection.updateSelectedCount;
		var syncMusicSelectAll = musicSelection.syncSelectAll;
		var applyMusicSelections = musicSelection.applySelections;
		var setMusicItemSelected = musicSelection.setItemSelected;
		var bindMusicItems = musicSelection.bindItems;
		var syncSelectedMusicFromDom = function(){
			var selectedItems = [];
			getMusicItems().filter('.music-item-select').each(function(){
				selectedItems.push(getMusicItemData(this));
			});
			if(multiple){
				music_data_multiple = selectedItems;
			}else{
				music_data = selectedItems.length ? selectedItems[0] : {};
			}
			syncState();
		};
		var mobilePanels = null;
		var pagesize="25";
		if(musicCategory){
			var pagesize="20";
		}
		
		
		if($("#"+music_manage_div).length>0){

		}else{
			var html="";
			html=html+'<div id="'+music_manage_div+'" class="music-manage">';
			html=html+'<div id="'+music_manage+'" class="media-manage-shell" data-mobile-search="closed" data-mobile-category="closed">';
			html=html+createMediaMobileBar({
				categoryTriggerId: musicCategory ? music_mobile_category_toggle : '',
				searchTriggerId: music_mobile_search_toggle,
				categoryText: t('allMusic', '所有音乐'),
				searchText: t('search', '搜索')
			});
			html=html+'<div class="media-manage-stage'+(musicCategory ? ' media-manage-body-with-side' : '')+'">';
			if(musicCategory){
				html=html+'<div class="media-manage-side music-manage-side">';
				html=html+'<h3 class="music-manage-category-title" id="'+music_category_add+'">'+t('addGroup', '添加分组')+'</h3>';
				html=html+'<div class="music-manage-left-content" id="'+music_category+'"></div>';
				html=html+'</div>';
				html=html+'<div class="music-manage-right media-manage-main">';
			}else{
				html=html+'<div class="music-manage-right media-manage-main">';
			}
			
			html=html+'<div class="music-manage-header">';
			html=html+'<label>'+t('dateRange', '日期范围')+'</label>';
			html=html+'<input type="text" class="layui-input layui-input-sm" id="'+music_search_date+'" >';
			html=html+'<label>'+t('fileName', '文件名')+'</label>';
			html=html+'<input type="text" class="layui-input layui-input-sm" id="'+music_search_input+'" >';
			html=html+'<button class="layui-btn layui-btn-sm" id="'+music_search_btn+'"><i class="layui-icon">&#xe615;</i>'+t('search', '搜索')+'</button>';
			html=html+'</div>';
			if(musicCategory){
				html=html+'<div class="music-content" id="'+music_content+'">';
			}else{
				html=html+'<div class="music-content music-content-no" id="'+music_content+'">';
			}
			html=html+'</div>';
			html=html+'<div class="music_page">';
			if(multiple){
			html=html+'<div class="music_page_left">';
			html=html+'<input type="checkbox" id="'+music_select_all+'"/><span>'+t('selectAllPage', '本页全选')+'</span><label>'+t('selectedCount', '已选 {count} 个', {count: '__COUNT__'}).replace('__COUNT__', '<span id="'+music_select_all_num+'">0</span>')+'</label>';
			html=html+'</div>';
			}
			html=html+'<div class="music_page_right" id="'+music_page+'"></div>';
			html=html+'</div>';
			html=html+'</div>';
			html=html+'</div>';
			var musicFooterActions='';
			musicFooterActions=musicFooterActions+'<a href="javascript:;" id="'+music_del+'" class="layui-btn layui-btn-sm layui-btn-danger media-manage-action media-manage-action-delete">'+t('delete', '删除')+'</a>';
			if(musicCategory){
				musicFooterActions=musicFooterActions+'<a href="javascript:;" id="'+music_move+'" class="layui-btn layui-btn-sm layui-btn-normal media-manage-action media-manage-action-move">'+t('move', '移动')+'</a>';
			}
			musicFooterActions=musicFooterActions+'<a href="javascript:;" id="'+music_upload+'" class="layui-btn layui-btn-sm layui-bg-green media-manage-action media-manage-action-upload">'+t('uploadMusic', '上传音乐')+'</a>';
			html=html+createMediaDialogFooter({
				actionsHtml: musicFooterActions,
				confirmId: music_confirm,
				cancelId: music_cancel,
				confirmText: t('confirm', '确定'),
				cancelText: t('cancel', '取消')
			});
			html=html+'</div>';
			$('body').append(html);
			
			if(multiple){
				$("#"+music_select_all).click(function(){
					var checked=$(this).prop('checked');
					getMusicItems().each(function(){
						setMusicItemSelected(this, checked);
					});
				});
			}
			/*时间范围选择*/
			laydate.render({
				elem: '#'+music_search_date
				,range: true
				,done: function(value, date, endDate){
					music_s_time=Date.parse(date.year+"-"+date.month+"-"+date.date+" "+date.hours+":"+date.minutes+":"+date.seconds)/1000;
					music_e_time=Date.parse(endDate.year+"-"+endDate.month+"-"+endDate.date+" "+date.hours+":"+date.minutes+":"+date.seconds)/1000+24*60*60;
				}
			});
			if(musicCategory){
				/*移动图片*/
				$("#"+music_move).click(function(){
					var html="";
					html=html+"<form class='layui-form music-layer-form' lay-filter='"+music_manage+"_filter'>"+createMediaFormFieldHtml({label:t('selectGroup', '选择分组'),fieldHtml:"<select id='"+music_manage+"_select' class='layui-select'>"});
					html=html+(category_tree ? category_tree.buildMoveOptionsHtml() : "<option value='0'>"+t('allMusic', '所有音乐')+"</option>");
					html=html+"</select></div></div></form>";
					if(multiple==false){
						var arr = Object.keys(music_data); 
						if(arr.length>0){
							layer.open({
								type: 1,
								title: t('moveMusic', '移动音乐'),
								closeBtn: 1,
								shadeClose: false,
								skin: musicDialogOptions.skin,
								resize:false,
								scrollbar:false,
								area: musicDialogOptions.area,
								content: html,
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								success: function(layero, index){
									form.render('select', music_manage+'_filter');
								},
								yes:function(index, layero){
									layer.close(index);
									var load=layer.load();
									$.ajax({
										type:'post',
										dataType:'json',
										url:musicMoveUrl,
										data:{id:music_data['id'],category_id:$("#"+music_manage+'_select').val()},
				success:function(result){
					layer.close(load);
											if(result.code==0){
												layer.msg(t('moveSuccess', '移动成功'));
												$("#"+music_item+"_"+music_data['id']).remove();
												music_data={};
											}else{
												layer.msg(t('moveFailed', '移动失败'));
											}
										}
									})
								}
							})
						}else{
							layer.msg(t('selectMusicToMove', '请选择要移动的音乐?'));
						}
					}else{
						if(music_data_multiple.length>0){
							layer.open({
								type: 1,
								title: t('moveMusic', '移动音乐'),
								closeBtn: 1,
								shadeClose: false,
								skin: musicDialogOptions.skin,
								resize:false,
								scrollbar:false,
								area: musicDialogOptions.area,
								content: html,
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								success: function(layero, index){
									form.render('select', music_manage+'_filter');
								},
								yes:function(index, layero){
									layer.close(index);
									var load=layer.load();
									var ids=Array();
									for(let i in music_data_multiple){
										ids.push(music_data_multiple[i]['id']);
									}
									$.ajax({
										type:'post',
										dataType:'json',
										url:musicMoveUrl,
										data:{id:ids,category_id:$("#"+music_manage+'_select').val()},
										success:function(result){
											layer.close(load);
											if(result.code==0){
												layer.msg(t('moveSuccess', '移动成功'));
												for(let i in music_data_multiple){
													$("#"+music_item+"_"+music_data_multiple[i]['id']).remove();
												}
												music_data_multiple=Array();
												$("#"+music_select_all_num).text(music_data_multiple.length);
											}else{
												layer.msg(t('moveFailed', '移动失败'));
											}
										}
									})
								}
							})
						}else{
							layer.msg(t('selectMusicToMove', '请选择要移动的音乐?'));
						}
					}
				});
			}
			/*删除事件*/
			$("#"+music_del).click(function(){
				if(multiple==false){
					var arr = Object.keys(music_data); 
					if(arr.length>0){
						layer.open({
							type: 1,
							title: t('deleteMusic', '删除音乐'),
							closeBtn: 1,
							shadeClose: false,
							skin: musicDialogOptions.skin,
							resize:false,
							scrollbar:false,
							area: musicDialogOptions.area,
							content: createMediaConfirmHtml(t('confirmDeleteMusic', '真的要删除选择的音乐吗?')),
							btn: [t('confirm', '确定'), t('cancel', '取消')],
							yes:function(index, layero){
								layer.close(index);
								var load=layer.load();
								$.ajax({
									type:'post',
									dataType:'json',
									url:musicDelUrl,
									data:{id:music_data['id']},
									success:function(result){
										layer.close(load);
										if(result.code==0){
											layer.msg(t('deleteSuccess', '删除成功'));
											$("#"+music_item+"_"+music_data['id']).remove();
											music_data={};
										}else{
											layer.msg(t('deleteFailed', '删除失败'));
										}
									}
								})
							}
						})
					}else{
						layer.msg(t('selectMusicToDelete', '请选择要删除的音乐?'));
					}
				}else{
					if(music_data_multiple.length>0){
						layer.open({
							type: 1,
							title: t('deleteMusic', '删除音乐'),
							closeBtn: 1,
							shadeClose: false,
							skin: musicDialogOptions.skin,
							resize:false,
							scrollbar:false,
							area: musicDialogOptions.area,
							content: createMediaConfirmHtml(t('confirmDeleteMusic', '真的要删除选择的音乐吗?')),
							btn: [t('confirm', '确定'), t('cancel', '取消')],
							success: function(layero, index){
								
							},
							yes:function(index, layero){
								layer.close(index);
								var load=layer.load();
								var ids=Array();
								for(let i in music_data_multiple){
									ids.push(music_data_multiple[i]['id']);
								}
								$.ajax({
									type:'post',
									dataType:'json',
									url:musicDelUrl,
									data:{id:ids},
									success:function(result){
										layer.close(load);
										if(result.code==0){
											layer.msg(t('deleteSuccess', '删除成功'));
											for(let i in music_data_multiple){
												$("#"+music_item+"_"+music_data_multiple[i]['id']).remove();
											}
											music_data_multiple=Array();
											$("#"+music_select_all_num).text(music_data_multiple.length);
										}else{
											layer.msg(t('deleteFailed', '删除失败'));
										}
									}
								})
							}
						})
					}else{
						layer.msg(t('selectMusicToDelete', '请选择要删除的音乐?'));
					}
				}
			});
			/*搜索事件*/
			$("#"+music_search_btn).click(function(data){
				uploadMusic.reload({data:{category_id:category_id}});
				var load=layer.load();
				if($("#"+music_search_date).val()==''){
					music_s_time=0;
					music_e_time=0;
				}
				$.ajax({
					type:'post',
					dataType:'json',
					url:musicUrl,
					data:{s_time:music_s_time,e_time:music_e_time,page:1,category_id:category_id,name:$("#"+music_search_input).val(),pagesize:pagesize},
					success:function(result){
						layer.close(load);
						$("#"+music_content).empty();
						var list = result.data;
						music_total=result.count;
						for(var i=0;i<list.length;i++){
							$("#"+music_content).append("<a data-id='"+list[i].id+"' data-path='"+escapeHtml(list[i].path)+"' data-size='"+escapeHtml(list[i].size)+"' id='"+music_item+'_'+list[i].id+"'><audio src='"+escapeHtml(list[i].path)+"' controls='controls'></audio><label class='music_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-eye music-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
						}
						applyMusicSelections();
						bindMusicItems();
						/*编辑文件名*/
						$("#"+music_content+" a label i").off();
						$("#"+music_content+" a label i").click(function(event){
							event.stopPropagation();
							that=$(this).parent();
							if($(this).hasClass('music-preview-trigger')){
								openMusicPreview(that.parent().attr('data-path'));
							}
							if($(this).hasClass('layui-icon-edit')){
								var name=that.find('span').text();
								var tmp_id=that.attr('data');
								layer.open({
									type: 1,
									title: t('renameFile', '修改文件名【{name}】', {name: name}),
									closeBtn: 1,
									shadeClose: false,
									skin: 'layui-layer-g3ys-form',
									resize:false,
									scrollbar:false,
									area: ['470px', '230px'],
									content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
									btn: [t('confirm', '确定'), t('cancel', '取消')],
									yes:function(index, layero){
										layer.close(index);
										var tmp_val=trimText($(layero).find('input').val());
										if(tmp_val!=''){
											var load=layer.load();
											$.ajax({
												type:'post',
												dataType:'json',
												url:editMusicNameUrl,
												data:{id:tmp_id,name:tmp_val},
												success:function(result){
													layer.close(load);
													if(result.code==0){
														layer.msg(t('renameSuccess', '修改成功'));
														$(".music_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
													}else{
														layer.msg(t('renameFailed', '修改失败'));
													}
												}
											})
										}else{
											layer.msg(t('fileNameRequired', '文件名不能为空'));
										}
									}
								});
							}
						});
						laypage.render({
							elem: music_page
							,count: music_total
							,limit:15
							,jump: function(obj, first){
								if(!first){
									$("#"+music_content).empty();
									$.ajax({
										type:'post',
										dataType:'json',
										url:musicUrl,
										data:{s_time:music_s_time,e_time:music_e_time,page:obj.curr,category_id:category_id,pagesize:pagesize},
										success:function(result){
											$("#"+music_content).empty();
											var list = result.data;
											for(var i=0;i<list.length;i++){
												$("#"+music_content).append("<a data-id='"+list[i].id+"' data-path='"+escapeHtml(list[i].path)+"' data-size='"+escapeHtml(list[i].size)+"' id='"+music_item+"_"+list[i].id+"'><audio controls='controls' src='"+escapeHtml(list[i].path)+"'></audio><label class='music_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-eye music-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
											}
											$("#"+music_content+" a").click(function(){
												if($(this).hasClass('music-item-select')){
													$(this).removeClass('music-item-select');
													let tmp_id=$(this).attr('data-id');
													if(multiple==false){
														music_data={};
													}else{
														for(let i in music_data_multiple){
															if(music_data_multiple[i]['id']==tmp_id){
																music_data_multiple.splice(i,1);
															}
														}
														$("#"+music_select_all_num).text(music_data_multiple.length);
													}
												}else{
													if(multiple==false){
														$("#"+music_content+" a").removeClass('music-item-select');
														music_data={id:$(this).attr('data-id'),path:$(this).attr('data-path'),size:$(this).attr('data-size'),title:$(this).find('span').text()};
													}else{
														if(music_data_multiple.length>=musicMax){
															layer.msg(t('maxSelect', '最多只能选{max}个', {max: musicMax}));
															return false;
														}else{
															var tmp_music_data={id:$(this).attr('data-id'),path:$(this).attr('data-path'),size:$(this).attr('data-size'),title:$(this).find('span').text()};
															music_data_multiple.push(tmp_music_data);
															$("#"+music_select_all_num).text(music_data_multiple.length);
															$(this).addClass('music-item-select');
														}
													}
													$(this).addClass('music-item-select');
												}
											});
											/*编辑文件名*/
										$("#"+music_content+" a label i").off();
										$("#"+music_content+" a label i").click(function(event){
											event.stopPropagation();
											that=$(this).parent();
											
											if($(this).hasClass('music-preview-trigger')){
												openMusicPreview(that.parent().attr('data-path'));
											}
											if($(this).hasClass('layui-icon-edit')){
												var name=that.find('span').text();
												var tmp_id=that.attr('data');
												layer.open({
													type: 1,
													title: t('renameFile', '修改文件名【{name}】', {name: name}),
													closeBtn: 1,
													shadeClose: false,
													skin: 'layui-layer-g3ys-form',
													resize:false,
													scrollbar:false,
													area: ['470px', '230px'],
													content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
													btn: [t('confirm', '确定'), t('cancel', '取消')],
													yes:function(index, layero){
														layer.close(index);
														var tmp_val=trimText($(layero).find('input').val());
														if(tmp_val!=''){
															var load=layer.load();
															$.ajax({
																type:'post',
																dataType:'json',
																url:editMusicNameUrl,
																data:{id:tmp_id,name:tmp_val},
																success:function(result){
																	layer.close(load);
																	if(result.code==0){
																		layer.msg(t('renameSuccess', '修改成功'));
																		$(".music_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
																	}else{
																		layer.msg(t('renameFailed', '修改失败'));
																	}
																}
															})
														}else{
															layer.msg(t('fileNameRequired', '文件名不能为空'));
														}
													}
												});
											}
										});
										}
									})
								}
							}
						});
					}
				});
				mobilePanels && mobilePanels.closeSearch();
				return false;
			});
		
		/*初始上传按钮*/
		var uploadMusic=upload.render({
			elem: '#'+music_upload
			,url: musicUploadUrl
			,field:field||'file'
			,accept:'audio'
			,acceptMime:acceptMime||'audio/mpeg'
			,size:size||200*1024*1024
			,headers:headers||''
			,exts:exts||'mp3'
			,data:musicUploadData||''
			,multiple:multiple
			,before:function(obj){
				layer.load();
			}
			,done: function(result){
				layer.closeAll('loading'); 
				if(result.code=='0'){
					$("#"+music_content).prepend("<a data-id='"+result.data.id+"' data-path='"+escapeHtml(result.data.path)+"' data-size='"+escapeHtml(result.data.size)+"'  id='"+music_item+'_'+result.data.id+"'><audio controls='controls' src='"+escapeHtml(result.data.path)+"'></audio><label class='music_item_label' data='"+result.data.id+"'><span>"+escapeHtml(result.data.name)+"</span><i class='layui-icon layui-icon-eye music-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
					applyMusicSelections();
					bindMusicItems();
					/*编辑文件名*/
					$("#"+music_content+" a label i").off();
					$("#"+music_content+" a label i").click(function(event){
						event.stopPropagation();
						that=$(this).parent();
						if($(this).hasClass('music-preview-trigger')){
							openMusicPreview(that.parent().attr('data-path'));
						}
						if($(this).hasClass('layui-icon-edit')){
							var name=that.find('span').text();
							var tmp_id=that.attr('data');
							layer.open({
								type: 1,
								title: t('renameFile', '修改文件名【{name}】', {name: name}),
								closeBtn: 1,
								shadeClose: false,
								skin: 'layui-layer-g3ys-form',
								resize:false,
								scrollbar:false,
								area: ['470px', '230px'],
								content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								yes:function(index, layero){
									layer.close(index);
									var tmp_val=trimText($(layero).find('input').val());
									if(tmp_val!=''){
										var load=layer.load();
										$.ajax({
											type:'post',
											dataType:'json',
											url:editMusicNameUrl,
											data:{id:tmp_id,name:tmp_val},
											success:function(result){
												layer.close(load);
												if(result.code==0){
													layer.msg(t('renameSuccess', '修改成功'));
													$(".music_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
												}else{
													layer.msg(t('renameFailed', '修改失败'));
												}
											}
										})
									}else{
										layer.msg(t('fileNameRequired', '文件名不能为空'));
									}
								}
							});
						}
					});
					setMusicItemSelected($("#"+music_item+"_"+result.data.id), true);
				}else{
					layer.msg(result.msg);
				}
			}
		});
		if(musicCategory){
			/*添加分类*/
			$("#"+music_category_add).off();
			category_tree = createMediaCategoryTree({
				elem: "#"+music_category,
				addButton: "#"+music_category_add,
				categoryUrl: musicCategoryUrl,
				updateUrl: musicCategoryUpdateUrl,
				deleteUrl: musicCategoryDelUrl,
				allLabel: t('allMusic', '所有音乐'),
				getSelectedId: function(){
					return category_id;
				},
				setSelectedId: function(value){
					category_id = value;
					syncState();
				},
				onSelect: function(){
					$("#"+music_search_btn).click();
					mobilePanels && mobilePanels.closeCategory();
				},
				texts: {
					addGroup: t('addGroup', '添加分组'),
					newGroup: t('newGroup', '新建分组'),
					groupName: t('groupName', '分组名称'),
					groupNameRequired: t('groupNameRequired', '请填写分组名称'),
					confirm: t('confirm', '确定'),
					cancel: t('cancel', '取消'),
					edit: t('edit', '修改'),
					delete: t('delete', '删除'),
					deleteGroup: t('deleteGroup', '删除分组'),
					confirmDeleteGroup: t('confirmDeleteGroup', '真的要删除该分组吗?'),
					deleteGroupWithChildren: t('deleteGroupWithChildren', '请先删除子分组'),
					renameSuccess: t('renameSuccess', '修改成功'),
					renameFailed: t('renameFailed', '修改失败'),
					deleteSuccess: t('deleteSuccess', '删除成功'),
					deleteFailed: t('deleteFailed', '删除失败')
				}
			});
			init_categorys = category_tree.reload;
			syncState();
			init_categorys();
		}
		/*获取图片*/
		$.ajax({
				type:'post',
				dataType:'json',
				url:musicUrl,
				data:{s_time:music_s_time,e_time:music_e_time,page:1,category_id:category_id,pagesize:pagesize},
				success:function(result){
					$("#"+music_content).empty();
					var list = result.data;
					music_total=result.count;
					if(list){
						for(var i=0;i<list.length;i++){
							$("#"+music_content).append("<a data-id='"+list[i].id+"' data-path='"+escapeHtml(list[i].path)+"' data-size='"+escapeHtml(list[i].size)+"' id='"+music_item+"_"+list[i].id+"'><audio  controls='controls' src='"+escapeHtml(list[i].path)+"'></audio><label class='music_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-eye music-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
						}
					}
					/*设置已选择样式*/
					for(let i in music_data_multiple){
						$("#"+music_item+"_"+music_data_multiple[i].id).addClass('music-item-select');
					}
					/*全选按钮*/
					var isall=true;
					$("#"+music_content+" a").each(function(){
						if(!$(this).hasClass('music-item-select')){
							isall=false;
						}
					});
					if(isall){
						$("#"+music_select_all).prop('checked',true);
					}else{
						$("#"+music_select_all).prop('checked',false);
					}
					$("#"+music_content+" a").click(function(){
						if($(this).hasClass('music-item-select')){
							$(this).removeClass('music-item-select');
							let tmp_id=$(this).attr('data-id');
							if(multiple==false){
								music_data=Array();
							}else{
								for(let i in music_data_multiple){
									if(music_data_multiple[i]['id']==tmp_id){
										music_data_multiple.splice(i,1);
									}
								}
								$("#"+music_select_all_num).text(music_data_multiple.length);
							}
						}else{
							if(multiple==false){
								$("#"+music_content+" a").removeClass('music-item-select');
								music_data={id:$(this).attr('data-id'),path:$(this).attr('data-path'),size:$(this).attr('data-size'),title:$(this).find('span').text()};
							}else{
								if(music_data_multiple.length>=musicMax){
									layer.msg(t('maxSelect', '最多只能选{max}个', {max: musicMax}));
									return false;
								}else{
									var tmp_music_data={id:$(this).attr('data-id'),path:$(this).attr('data-path'),size:$(this).attr('data-size'),title:$(this).find('span').text()};
									music_data_multiple.push(tmp_music_data);
									$("#"+music_select_all_num).text(music_data_multiple.length);
									$(this).addClass('music-item-select');
								}
							}
							$(this).addClass('music-item-select');
						}

						/*全选按钮*/
						var isall=true;
						$("#"+music_content+" a").each(function(){
							if(!$(this).hasClass('music-item-select')){
								isall=false;
							}
						});
						if(isall){
							$("#"+music_select_all).prop('checked',true);
						}else{
							$("#"+music_select_all).prop('checked',false);
						}
					});
					/*编辑文件名*/
					$("#"+music_content+" a label i").click(function(event){
						event.stopPropagation();
						that=$(this).parent();
						if($(this).hasClass('music-preview-trigger')){
							openMusicPreview(that.parent().attr('data-path'));
						}
						if($(this).hasClass('layui-icon-edit')){
							var name=that.find('span').text();
							var tmp_id=that.attr('data');
							layer.open({
								type: 1,
								title: t('renameFile', '修改文件名【{name}】', {name: name}),
								closeBtn: 1,
								shadeClose: false,
								skin: 'layui-layer-g3ys-form',
								resize:false,
								scrollbar:false,
								area: ['470px', '230px'],
								content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
								btn: [t('confirm', '确定'), t('cancel', '取消')],
								yes:function(index, layero){
									layer.close(index);
									var tmp_val=trimText($(layero).find('input').val());
									if(tmp_val!=''){
										var load=layer.load();
										$.ajax({
											type:'post',
											dataType:'json',
											url:editMusicNameUrl,
											data:{id:tmp_id,name:tmp_val},
											success:function(result){
												layer.close(load);
												if(result.code==0){
													layer.msg(t('renameSuccess', '修改成功'));
													$(".music_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
												}else{
													layer.msg(t('renameFailed', '修改失败'));
												}
											}
										})
									}else{
										layer.msg(t('fileNameRequired', '文件名不能为空'));
									}
								}
							});
						}
					});

					laypage.render({
						elem: music_page
						,count: music_total
						,limit:15
						,jump: function(obj, first){

							if(!first){
								$.ajax({
									type:'post',
									dataType:'json',
									url:musicUrl,
									data:{s_time:music_s_time,e_time:music_e_time,page:obj.curr,category_id:category_id,pagesize:pagesize},
									success:function(result){
										$("#"+music_content).empty();
										var list = result.data;
										for(var i=0;i<list.length;i++){
											$("#"+music_content).append("<a data-id='"+list[i].id+"' data-path='"+escapeHtml(list[i].path)+"' data-size='"+escapeHtml(list[i].size)+"' id='"+music_item+"_"+list[i].id+"'><audio controls='controls' src='"+escapeHtml(list[i].path)+"'></audio><label class='music_item_label' data='"+list[i]['id']+"'><span>"+escapeHtml(list[i].name)+"</span><i class='layui-icon layui-icon-eye music-preview-trigger'></i><i class='layui-icon layui-icon-edit'></i></label><ins><i class='layui-icon layui-icon-ok'></i></ins></a>");
										}
										/*设置已选择样式*/
										for(let i in music_data_multiple){
											$("#"+music_item+"_"+music_data_multiple[i].id).addClass('music-item-select');
										}
										/*全选按钮*/
										var isall=true;
										$("#"+music_content+" a").each(function(){
											if(!$(this).hasClass('music-item-select')){
												isall=false;
											}
										});
										if(isall){
											$("#"+music_select_all).prop('checked',true);
										}else{
											$("#"+music_select_all).prop('checked',false);
										}
										$("#"+music_content+" a").off();
										$("#"+music_content+" a").click(function(){
											if($(this).hasClass('music-item-select')){
												$(this).removeClass('music-item-select');
												let tmp_id=$(this).attr('data-id');
												if(multiple==false){
													music_data=Array();
												}else{
													for(let i in music_data_multiple){
														if(music_data_multiple[i]['id']==tmp_id){
															music_data_multiple.splice(i,1);
														}
													}
													$("#"+music_select_all_num).text(music_data_multiple.length);
												}
											}else{
												if(multiple==false){
													$("#"+music_content+" a").removeClass('music-item-select');
													music_data={id:$(this).attr('data-id'),path:$(this).attr('data-path'),size:$(this).attr('data-size'),title:$(this).find('span').text()};
												}else{
													if(music_data_multiple.length>=musicMax){
														layer.msg(t('maxSelect', '最多只能选{max}个', {max: musicMax}));
														return false;
													}else{
														var tmp_music_data={id:$(this).attr('data-id'),path:$(this).attr('data-path'),size:$(this).attr('data-size'),title:$(this).find('span').text()};
														music_data_multiple.push(tmp_music_data);
														$("#"+music_select_all_num).text(music_data_multiple.length);
														$(this).addClass('music-item-select');
													}
												}
												$(this).addClass('music-item-select');
											}
											/*全选按钮*/
											var isall=true;
											$("#"+music_content+" a").each(function(){
												if(!$(this).hasClass('music-item-select')){
													isall=false;
												}
											});
											if(isall){
												$("#"+music_select_all).prop('checked',true);
											}else{
												$("#"+music_select_all).prop('checked',false);
											}
										});

										/*编辑文件名*/
										$("#"+music_content+" a label i").off();
										$("#"+music_content+" a label i").click(function(event){
											event.stopPropagation();
											that=$(this).parent();
											if($(this).hasClass('music-preview-trigger')){
												openMusicPreview(that.parent().attr('data-path'));
											}
											if($(this).hasClass('layui-icon-edit')){
												var name=that.find('span').text();
												var tmp_id=that.attr('data');
												layer.open({
													type: 1,
													title: t('renameFile', '修改文件名【{name}】', {name: name}),
													closeBtn: 1,
													shadeClose: false,
													skin: 'layui-layer-g3ys-form',
													resize:false,
													scrollbar:false,
													area: ['470px', '230px'],
													content: "<div class='layui-form-item' style='padding-top:50px;padding-right:30px;'><label class='layui-form-label'>"+t('fileNameLabel', '文件名')+"</label><div class='layui-input-block'><input type='text' value='"+name+"' class='layui-input'></div></div>",
													btn: [t('confirm', '确定'), t('cancel', '取消')],
													yes:function(index, layero){
														layer.close(index);
														var tmp_val=trimText($(layero).find('input').val());
														if(tmp_val!=''){
															var load=layer.load();
															$.ajax({
																type:'post',
																dataType:'json',
																url:editMusicNameUrl,
																data:{id:tmp_id,name:tmp_val},
																success:function(result){
																	layer.close(load);
																	if(result.code==0){
																		layer.msg(t('renameSuccess', '修改成功'));
																		$(".music_item_label[data='"+tmp_id+"']").find('span').text(tmp_val);
																	}else{
																		layer.msg(t('renameFailed', '修改失败'));
																	}
																}
															})
														}else{
															layer.msg(t('fileNameRequired', '文件名不能为空'));
														}
													}
												});
											}
										});
									}
								})
							}
						}
					});
				}
			});
			
		}
		
		
		var layerOptions = getMediaManageLayerOptions();
		this.options.layer=layer.open({
			  type: 1,
			  title: t('selectMusic', '选择音乐'),
			  closeBtn: 1,
			  shadeClose: false,
			  skin: 'layui-layer-g3ys-form-big media-manage-layer',
			  resize:false,
			  scrollbar:false,
			  area: layerOptions.area,
			  offset: layerOptions.offset,
			  content: $('#'+music_manage_div),
			  success: function(layero, index){
					mobilePanels = bindMediaMobilePanels({
						shellId: music_manage,
						categoryTriggerId: musicCategory ? music_mobile_category_toggle : '',
						searchTriggerId: music_mobile_search_toggle
					});
					bindMediaDialogFooter({
						confirmId: music_confirm,
						cancelId: music_cancel,
						onConfirm: function(){
							syncSelectedMusicFromDom();
							layer.close(index);
							if(multiple){
								if(music_data_multiple.length>0){
									for(let i in music_data_multiple){
										let item=music_data_multiple[i];
										var arr = Object.keys(item);
										(callback && typeof(callback)==="function"&&arr.length>0) && callback('select',item['id'],item);
									}
									music_data_multiple=Array();
									$("#"+music_select_all).prop('checked',false);
									$("#"+music_content+" a").removeClass("music-item-select");
									updateMusicSelectedCount();
								}
							}else{
								var arr = Object.keys(music_data); 
								(callback && typeof(callback)==="function"&&arr.length>0) && callback('select',music_data['id'],music_data);
								music_data={};
								$("#"+music_content+" a").removeClass("music-item-select");
							}
							$("#"+music_manage_div).hide();
						},
						onCancel: function(){
							layer.close(index);
						}
					});
					$("#"+music_manage_div).show();
					layer.close(load);
			  },
			  end:function(){
					$("#"+music_manage_div).hide();
			  }
		});
	}
	musicManage.prototype.close=function(){
		layer.close(this.options.layer);
	}
export { MusicManage as musicManage };
